export default {"src":"/_next/static/media/kyc-filled.75b0e797.svg","height":28,"width":28};